// The four tiles above the Runs register (plan §2D item 2). Independent of
// the list's filters; a failed read shows dashes and "not available", never
// zeros — the discriminator is readState's mustWithhold, not !isSuccess.
import { Link } from 'react-router-dom'
import { Kpi } from '@/components/Kpi'
import { mustWithhold, type ReadStateLike } from '@/lib/readState'
import { fmtPct, RUNS_ACTIVE_ALL_HISTORY_PATH } from '@/lib/runsRegister'
import { fmtKg, KPI_WINDOW_DAYS, type RunsKpis } from '@/lib/runsKpis'

const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? '' : 's'}`

export function RunsKpiStrip({ q }: { q: ReadStateLike & { data?: RunsKpis } }) {
  const k = mustWithhold(q) ? null : (q.data ?? null)
  const sub = (s: string) => k ? s : 'not available'
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" aria-label="Runs this week">
      {/* F02 UF-12: the whole tile opens the runs it counts (Active + Tipping
          stopped, all history). Only with a figure: a withheld tile has
          nothing to open. */}
      {k ? (
        <Link to={RUNS_ACTIVE_ALL_HISTORY_PATH} aria-label={`Active runs ${k.active}, show them`}
              className="block rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60">
          <Kpi label="Active runs" value={k.active} sub="right now · show them" />
        </Link>
      ) : (
        <Kpi label="Active runs" value="—" sub="not available" />
      )}
      <Kpi label={`Tipped · ${KPI_WINDOW_DAYS} days`} value={k ? fmtKg(k.tippedKg) : '—'} sub={sub(plural(k?.runsInWindow ?? 0, 'run') + ' started')} />
      <Kpi label={`Packed · ${KPI_WINDOW_DAYS} days`} value={k ? fmtKg(k.packedKg) : '—'} sub={sub(plural(k?.pallets ?? 0, 'pallet'))} />
      <Kpi label={`Packout · ${KPI_WINDOW_DAYS} days`} value={k ? fmtPct(k.ofTipped) : '—'} sub={sub('of tipped')}
           tone={k?.ofTipped != null && k.ofTipped < 85 ? 'warn' : 'neutral'} />
    </div>
  )
}
